import { render } from "./Rewards.vue?vue&type=template&id=e849b4dc&scoped=true"
import script from "./Rewards.vue?vue&type=script&lang=js"
export * from "./Rewards.vue?vue&type=script&lang=js"

import "./Rewards.vue?vue&type=style&index=0&id=e849b4dc&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e849b4dc"]])

export default __exports__